import React, { useState, useEffect } from "react"
import { useInput, InputProps } from "react-admin"
import Cron, {Locale} from "react-js-cron"
import "react-js-cron/dist/styles.css"
import { useTheme } from "@mui/material/styles"
import { ColorMode } from "@xyflow/react"
import { useLocale } from "ra-core"
import { FormControl, FormHelperText, Box } from "@mui/material"
import { CronWidget } from "components/ui/widgets"
import { Global, css } from "@emotion/react"

interface CronInputProps extends Omit<InputProps, 'onChange'> {
  defaultValue?: string
  fullWidth?: boolean
  readOnly?: boolean
  helperText?: string
}

const CronInput: React.FC<CronInputProps> = (props) => {
  const {
    defaultValue = '* * * * *',
    label,
    source,
    resource,
    readOnly = false,
    fullWidth = true,
    helperText,
    ...rest
  } = props
  
  const {
    field,
    fieldState: { error },
    formState: { isSubmitted },
    isRequired
  } = useInput({
    source,
    resource,
    defaultValue,
    ...rest
  })

  const [cronError, setCronError] = useState<string | null>(null)

  const handleCronChange = (value: string) => {
    try {
      // Проверяем только если значение действительно изменилось
      if (value !== defaultValue) {
        if (!value || value.trim() === '') {
          throw new Error('Invalid cron expression')
        }
      }
      field.onChange(value)
      setCronError(null)
    } catch (err) {
      setCronError((err as Error).message)
    }
  }

  return (
    <FormControl 
      error={!!(isSubmitted && (error || cronError))} // Проверяем ошибку только после отправки
      fullWidth={fullWidth}
      sx={{ mb: 2 }}
      required={isRequired}
    >
     <CronWidget value={field.value} setValue={handleCronChange} source={source} readOnly={readOnly} />
      
      {((isSubmitted && (error || cronError)) || helperText) && (
        <FormHelperText error={!!(isSubmitted && (error || cronError))}>
          {(isSubmitted && (error || cronError)) ? 
            (cronError || 'required') : 
            helperText}
        </FormHelperText>
      )}
    </FormControl>
  )
}

export default CronInput